import React from 'react';
import { Typography } from '@mui/material';

type LegacyAuditReconciliationDisplayProps = {
  totalDiscrepancy: any;
  reconciliation: any;
  onReconcile: (e: React.MouseEvent) => void;
  showDiscrepancy?: boolean;
};

const LegacyAuditReconciliationDisplay: React.FC<LegacyAuditReconciliationDisplayProps> = ({
  totalDiscrepancy,
  reconciliation,
  onReconcile,
  showDiscrepancy = true,
}) => {
  if (!showDiscrepancy) {
    return (
      <span style={{ color: '#666' }} title="Discrepancy available only when POS and Lotto are both integrated">-</span>
    );
  }

  if (typeof totalDiscrepancy === 'object' && totalDiscrepancy && 'isNA' in totalDiscrepancy) {
    return <span style={{ color: '#666' }} title="No data available">-</span>;
  }

  if (reconciliation && reconciliation.hasReconciliation) {
    const reconciledAmount = reconciliation.amountValue;
    const balanceToReconcile = totalDiscrepancy - reconciledAmount;

    if (Math.abs(balanceToReconcile) < 0.01) {
      return (
        <span
          className="reconciliation--reconciled"
          onClick={onReconcile}
          title="Click to view reconciliation details"
        >
          Reconciled
        </span>
      );
    }

    return (
      <Typography
        variant="body2"
        sx={{ color: '#0000FF', cursor: 'pointer', textDecoration: 'underline', textAlign: 'center' }}
        className="reconciliation--partial"
        onClick={onReconcile}
        title="Click to reconcile remaining discrepancy"
      >
        See Details
      </Typography>
    );
  }

  if (totalDiscrepancy === 0) {
    return (
      <Typography variant="body2" sx={{ color: 'green', fontSize: '32px', fontWeight: 600 }} title="All audits matched">
        &#10003;
      </Typography>
    );
  }

  const discrepancyClass = totalDiscrepancy > 0
    ? 'reconciliation--discrepancy--positive'
    : 'reconciliation--discrepancy--negative';

  return (
    <Typography
      variant="body2"
      sx={{ color: '#0000FF', cursor: 'pointer', textDecoration: 'underline' }}
      className={discrepancyClass}
      onClick={onReconcile}
      title="Click to reconcile this discrepancy"
    >
      See Details
    </Typography>
  );
};

export default LegacyAuditReconciliationDisplay;

